import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  button: {
    minWidth: 200
  }
});
